import { MatSnackBar } from '@angular/material/snack-bar';
import { DisplayService } from './../../core/services/display.service';
import { FormControl } from '@angular/forms';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-display-index',
  templateUrl: './display-index.component.html',
  styleUrls: ['./display-index.component.scss']
})
export class DisplayIndexComponent implements OnInit {

  public loading = false;
  public search = new FormControl();
  public displaysFiltered = [];
  public displays = [];

  constructor(private displayService: DisplayService, private toastr: MatSnackBar) { }

  ngOnInit(): void {
    this.loading = true;
    this.displayService.displays(sessionStorage.getItem("anbieterNummer")).subscribe(res => {
      this.displays = res as [];
      this.displaysFiltered = res as [];
      this.loading = false;
    }, err => {
      console.log(err);
      this.loading = false;
      this.toastr.open('Fehler beim Laden der Displays. Code: '+err.status, '', {panelClass: 'danger-snackbar'});
    })
  }

}
